import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import { OK } from 'http-status-codes';

import { types, actions } from './duck';
import { getAffiliateBusinessCoupons } from '../api';
import { markAsFavouriteSaga, removeFavouriteSaga } from '../../customerCoupons/favourite/saga';

function* getAffiliateBusinessCouponsSaga(action) {
  try {
    yield put(actions.request(action.id));

    const response = yield call(getAffiliateBusinessCoupons, action.id);

    if (response.status === OK) {
      yield put(actions.success(action.id, response.data));
    } else {
      yield put(actions.failure(action.id, response.statusText));
    }
  } catch (error) {
    yield put(actions.failure(action.id, error.message));
  }
}

export default function* saga() {
  yield takeEvery(types.GET_DETAIL, getAffiliateBusinessCouponsSaga);
  yield takeLatest(types.MARK_AS_FAVOURITE, markAsFavouriteSaga);
  yield takeLatest(types.REMOVE_FAVOURITE, removeFavouriteSaga);
}
